import { SdkConfigureStore } from "@payping/redux";
import { SdkStoreStates } from "@payping/redux/reducers";
import * as Sentry from "@sentry/react";

import persistConfig from "./persistConfig";

export interface AppStoreStates extends SdkStoreStates {}

const sentryReduxEnhancer = Sentry.createReduxEnhancer();

const appReducers = {};

export const reduxConfig: SdkConfigureStore = {
  appEnhancers: [sentryReduxEnhancer],
  appPersistConfig: persistConfig,
  // @ts-ignore wrong type
  appReducers,
};
